import { useState } from 'react';
import type { Partner } from '../../types/api';
import { Eyebrow } from '../ui';

function Logo({ p }: { p: Partner }) {
  const [failed, setFailed] = useState(false);
  const inner = p.image?.url && !failed
    ? <img src={p.image.url} alt={p.name} onError={() => setFailed(true)} className="max-h-full max-w-full object-contain opacity-70 grayscale transition duration-300 group-hover:opacity-100 group-hover:grayscale-0" />
    : <span className="px-3 text-center font-display text-lg font-bold leading-tight text-muted transition-colors group-hover:text-charcoal">{p.name}</span>;
  const cls = 'group flex h-20 w-44 shrink-0 items-center justify-center md:h-24 md:w-52';
  return p.website
    ? <a href={p.website} target="_blank" rel="noopener noreferrer" aria-label={p.name} className={cls}>{inner}</a>
    : <div className={cls} role="img" aria-label={p.name}>{inner}</div>;
}

/**
 * « Ils nous font confiance »: une seule rangée horizontale de logos, sur tous les écrans.
 * Elle défile en continu (la liste est répétée pour boucler sans trou) et s'arrête au survol ou au focus.
 * Si l'utilisateur préfère moins d'animations, la rangée devient défilable à la main.
 */
export default function PartnersStrip({ partners }: { partners: Partner[] }) {
  const list = partners.filter((p) => p.enable);
  if (list.length === 0) return null;
  // Un jeu doit être plus large que l'écran: on répète la liste jusqu'à 8 logos au moins
  const set = Array.from({ length: Math.max(1, Math.ceil(8 / list.length)) }, () => list).flat();

  return (
    <section className="bg-surface py-16 text-black md:py-20">
      <div className="site-container">
        <Eyebrow className="mb-10">Ils nous font confiance</Eyebrow>
      </div>
      <div className="marquee overflow-hidden [mask-image:linear-gradient(to_right,transparent,#000_8%,#000_92%,transparent)]">
        <ul className="marquee-track flex w-max items-center gap-10 md:gap-16">
          {[0, 1].map((copy) => set.map((p, i) => (
            <li key={`${copy}-${i}`} aria-hidden={copy === 1 ? true : undefined}><Logo p={p} /></li>
          )))}
        </ul>
      </div>
    </section>
  );
}
